export default {
  additional_questions: '',
  default_gender: 'male',
  tags: ['ללא_ניסיון', 'הנדסאי', 'מהנדס', 'בניין', 'מים', 'תחבורה', 'תכנון', 'ביצוע', 'פיקוח', 'ניהול', 'ניהול_עבודה', 'בכיר', 'הייטק', 'ערבית', 'בוגר_טרי', 'ניסיון_קבלנות', 'רשום_במה”ט', 'בנייה ירוקה', 'עוזר_בטיחות', 'אדריכלות'],
  is_job_title_mandatory: true,
  auto_description: {
    show_certification_date: false
  }
}
